/*
 * The 'properties.js' file is generated in the output directory next to this file
 * and contains the parameters configured in the current transformation.
 */
import properties from './properties.js';

/**
 * Get a property value
 * @param {string} property - The property name
 * @returns {string} The property value
 */
function get(property) {
    return properties[property];
}

/**
 * Get a boolean property value
 * @param {string} property - The property name
 * @returns {boolean} The property value as boolean
 */
function getBoolean(property) {
    const prop = properties[property];
    return prop == 'true' || prop == 'yes';
}

/**
 * Get the indexer language
 * @returns {string} The indexer language
 */
function getIndexerLanguage() {
    // Implementation copied from IndexerTask.setIndexerLanguage()
    let language = get('webhelp.language');
    if (language) {
        const pos = language.indexOf('_');
        if (pos != -1) {
            language = language.substring(0, pos);
        }
    }
    return language;
}

export default {
    get,
    getBoolean,
    getIndexerLanguage
};
